module.exports = fox._r("images/ad_next.png", __webpack_public_path__ + "images/ad_next.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ad_next.png
// module id = 969
// module chunks = 4